export default __webpack_public_path__ + "static/media/team.aab30264.svg";